import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=2bf748f6"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf748f6')) {
      api.createRecord('2bf748f6', component.options)
    } else {
      api.reload('2bf748f6', component.options)
    }
    module.hot.accept("./HomeLayout.vue?vue&type=template&id=2bf748f6", function () {
      api.rerender('2bf748f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/HomeLayout.vue"
export default component.exports